import { toast } from "react-toastify";

export const copy = (text: string) => {
  navigator.clipboard.writeText(text);
  toast("Copied to clipboard");
};
